import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import InputVoucherItems from "../../components/commons/voucher/InputVoucherItems";

function VoucherModal({ show, toggle, type, action, data, register }) {

    const title = type === "add" ? "Klaim Voucher" : "Edit Voucher"

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}>
                <ModalHeader className="text-extra-bold pt-5"> {title} <span className="close clickable click-in-right" onClick={toggle}>&times;</span></ModalHeader>
                
                

                <ModalBody>
                    <InputVoucherItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default VoucherModal
